import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from './search-country.pipe';
import { Country } from './country.model';

@Component({
    selector: 'oao-mat-intl-tel-country-dialog',
    templateUrl: './ngx-mat-intl-tel-country-dialog.component.html',
    styleUrls: ['./ngx-mat-intl-tel-country-dialog.component.scss'],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
		SearchPipe
    ]
})
export class OaoMatIntlTelCountryDialogComponent {

	preferredCountriesInDropDown: Array<Country> = [];
	allCountries: Array<Country> = [];
	searchPlaceholder: string;
	enableSearch = false;
	searchCriteria: string;

	constructor(
		public dialogRef: MatDialogRef<OaoMatIntlTelCountryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	onCountrySelect(country: Country): void {
		this.dialogRef.close(country);
	}
	cancel(): void {
		this.dialogRef.close();
	}

}
